import { render } from "./CNetListModal.vue?vue&type=template&id=63f24bf2"
import script from "./CNetListModal.vue?vue&type=script&lang=js"
export * from "./CNetListModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__